var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("メンテナンスページ")]),_c('hr',{staticClass:"ma-5"}),_c('h3',[_vm._v("保存データ")]),_c('v-row',{attrs:{"justify":"start"}},[_c('v-col',[_c('v-btn',{on:{"click":_vm.deleteUser}},[_vm._v("Del")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }